'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ScopeChangeShowCtrl
 * @description
 * # ScopeChangeShowCtrl
 * Detalle de una solicitud de cambio de alcance. Es a donde lleva la liga del
 * correo de notificacion.
 */
angular.module('thothApp.controllers')
  .controller('ScopeChangeShowCtrl', [
  '$scope', '$stateParams', '$window', 'ScopeChangeRequest', 'ScopeChangeReview', 'toaster',
  function ($scope, $stateParams, $window, ScopeChangeRequest, ScopeChangeReview, toaster) {
      $scope.loading = true;
      $scope.reviewing = false;

      if ('apiUser' in $window.localStorage) {
        $scope.canReview = JSON.parse($window.localStorage.apiUser).project_management_role === true;
      }

      $scope.load = function() {
        $scope.loading = true;
        ScopeChangeRequest.find($stateParams.requestId).then(function(response) {
          $scope.request = response.data.scope_change_request;
          $scope.loading = false;
        }, function(error) {
          $scope.loading = false;
          ScopeChangeRequest.error(error);
        });
      };

      function review(action, mensaje) {
        $scope.reviewing = true;

        ScopeChangeReview[action]($scope.request).then(function() {
          toaster.pop('success', 'Solicitud', mensaje);
          $scope.reviewing = false;
          $scope.load();
        }).catch(function(error) {
          $scope.reviewing = false;
          ScopeChangeReview.report(error, toaster);
          $scope.load();
        });
      }

      $scope.approve = function() {
        review('approve', 'La solicitud se aprobó y el proyecto quedó creado');
      };

      $scope.reject = function() {
        review('reject', 'La solicitud se rechazó correctamente');
      };

      $scope.load();
  }]);
